import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App grain" data-testid="app-root">
        <Home />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0A111D",
              color: "#F8FAFC",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "2px",
              fontFamily: "IBM Plex Mono, monospace",
            },
          }}
        />
      </div>
    </ReactLenis>
  );
}

export default App;
